import React, { useState } from 'react';
import TablePage from '../../../../../../components/pages/TablePage';
import Awbs from './awbs';
import { RiFileTransferLine } from 'react-icons/ri';
import { Modal, Form, Input, DatePicker, Col, Row } from 'antd';
import moment from 'moment';
import { PostAPI } from '../../../../../../redux';
import { useDispatch } from 'react-redux';

const ImportOutPJT = () => {
    const dispatch = useDispatch()

    const [modalVisible, setModalVisible] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [refresh, setRefresh] = useState(moment().unix());

    const [form] = Form.useForm();

    const showModal = (row) => {
        setSelectedRow(row);
        form.setFieldsValue({
            no_do: row?.no_do || '',
            tgl_do: null,
        });
        setModalVisible(true);
    };

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    const handleOk = async () => {
        setModalVisible(false);
        try {
            const values = await form.validateFields();
            const updatedAwbs = selectedRow?.awbs?.map(({
                _id,
                hawb_number,
                hawb_date,
                mawb_number,
                mawb_date,
                kd_dok_inout,
                no_dok_inout,
                tgl_dok_inout,
                kode_sarana_angkut,
                jml_kemas,
                bruto,
                exportir_npwp,
                exportir_name,
                no_bc11,
                tgl_bc11,
                no_pos_bc11,
                no_pol,
                no_segel_bc,
                kode_kemas
            }) => ({
                _id,
                hawb_number,
                mawb_number,
                kd_dok_inout: kd_dok_inout.toString(),
                no_dok_inout,
                kode_sarana_angkut: kode_sarana_angkut || "1",
                jml_kemas,
                bruto,
                exportir_npwp,
                exportir_name,
                no_bc11,
                no_pos_bc11,
                no_pol: no_pol || "B",
                peb_number: no_dok_inout,
                no_segel_bc,
                no_do: values?.no_do,
                tgl_do: values.tgl_do ? moment(values.tgl_do).format('YYYYMMDD') : null,
                tgl_dok_inout: tgl_dok_inout ? moment(tgl_dok_inout).format('YYYYMMDD') : null,
                tgl_bc11: tgl_bc11 ? moment(tgl_bc11).format('YYYYMMDD') : null,
                peb_date: tgl_dok_inout ? moment(tgl_dok_inout).format('YYYYMMDD') : null,
                mawb_date: mawb_date ? moment(mawb_date).format('YYYYMMDD') : null,
                hawb_date: hawb_date ? moment(hawb_date).format('YYYYMMDD') : null,
                tgl_segel_bc: moment().format('YYYYMMDD'),
                kode_kemas: kode_kemas?.toUpperCase(),
            }));

            for (let idx = 0; idx < updatedAwbs.length; idx += 1) {
                const data = updatedAwbs[idx];
                await dispatch(PostAPI({
                    url: 'api/v1/tps_import/import_out',
                    data: { ...data, wk_inout: moment().format('YYYYMMDDHHmmss') }
                }));
                if (idx < updatedAwbs.length - 1) {
                    await delay(3000);
                }
            }

            setRefresh(moment().unix())
            form.resetFields();
        } catch (err) {
            console.log('Validation Failed:', err);
        }
    };

    const handleCancel = () => {
        setModalVisible(false);
        form.resetFields();
    };

    const columns = [
        {
            selector: (row) => row?.flight_number,
            name: "Flight Number"
        },
        {
            selector: (row) => row?.flight_date,
            name: "Flight Date"
        },
        {
            name: "Send All",
            id: '_id',
            selector: (row) => (
                <RiFileTransferLine
                    size={20}
                    style={{ color: 'black', cursor: 'pointer' }}
                    onClick={() => showModal(row)}
                />
            )
        },
    ];

    return (
        <>
            <TablePage
                title={"Import Out PJT"}
                url="api/v1/tps_import/import_out_pjt"
                actionPosition={'right'}
                columns={columns}
                ExpandComponent={Awbs}
                refresh={refresh}
            />

            <Modal
                title="Input DO"
                visible={modalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Kirim"
                cancelText="Batal"
            >
                <Form form={form} layout="vertical">
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="NO DO"
                                name="no_do"
                            >
                                <Input autoComplete="off" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="TGL DO"
                                name="tgl_do"
                            >
                                <DatePicker
                                    style={{ width: '100%' }}
                                    format="DD-MMM-YYYY"
                                    allowClear={false}
                                    placeholder=""
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
};

export default ImportOutPJT;
